import src from "IMAGE";
export default { src, width: 1973, height: 320, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AM3E0j7Ty9g3uavAWa6etmewobhkqZmxbLChuGSol7BvUZgTzODEDZYAAAAASUVORK5CYII="};
